<template>
    <div>
        <el-tabs class="tabs" v-model="tabIndex" stretch>
            <el-tab-pane label="产品介绍" name="1">
                <div class="videos">
                    <div class="videoItem" v-for="(item, index) in videoList">
                        <div @click="playVideo(index)">
                            <video style="width: 100%;" :src="item.url" :ref="'video' + index" controls  @bindplay="playVideo(index)"  :poster="item.imgUrl"></video>
                        </div>
                        <div class="videoName">
                            {{ item.name }}
                        </div>
                    </div>
                </div>
            </el-tab-pane>
            <el-tab-pane label="登录试用" name="0">
                <div class="iframes">
                    <iframe style="width: 100%;height: 100vh;" :src="mmsrc" frameborder="0"></iframe>
                </div>
            </el-tab-pane>
          
        </el-tabs>

    </div>
</template>

<script>
import axios from 'axios'
export default {
    data() {
        return {
            videoList: [],
            mmsrc: 'https://sso.mapmost.com/#/login?action=logout&redirect_url=https%3A%2F%2Fwj.qq.com%2Fs2%2F12509804%2F5351%2F&from_url=https%3A%2F%2Fwww.mapmost.com%2F%23%2F&uuid=ed833c7f-9ca5-412c-ae59-6eab6159dd90',
            tabIndex: '1',
            imgArr: []
        }
    },
    mounted() {
        axios.get('https://www.dpark.com.cn/ycxxFileUrl/wxapplet/mapmost/video.json').then(res => {
            this.videoList = res.data.list;
            res.data.list.forEach(e => {
                // this.getVideoBase64(e.url)
            })
        })
    }, methods: {

        playVideo(index) {

            console.log(index, 'index')
            let _this = this;

            let currentIndex = 'video' + index; // 获取当前视频索引
            // 获取视频列表
            this.videoList.forEach((item, index) => { // 获取json对象并遍历, 停止非当前视频
                let temp = 'video' + index;
                if (temp != currentIndex) { //判断名字是否一致
                    // 暂停其余视频
                    let dom = document.getElementById(temp);
                    debugger

                    dom.pause(); //暂停视频播放事件
                }
            })
        },
        getVideoBase64(url) {
            let dataURL = ''
            let video = document.createElement('video')
            video.setAttribute('crossOrigin', 'anonymous') //处理跨域
            video.setAttribute('src', url)
            video.setAttribute('width', 375)
            video.setAttribute('height', 205)
            video.currentTime = 1
            video.addEventListener('loadeddata', () => {
                let canvas = document.createElement('canvas')
                let width = video.width //canvas的尺寸和图片一样
                let height = video.height
                canvas.width = width
                canvas.height = height
                canvas.getContext('2d').drawImage(video, 0, 0, width, height) //绘制canvas
                dataURL = canvas.toDataURL('image/jpeg') //转换为base64
               this.imgArr.push(dataURL)
            })
        }
    }
}
</script>

<style lang="scss"  scoped>
@media screen and (max-width:767px) {
    .videos {
        position: relative;
        overflow: hidden;
        overflow-y: auto;
        height: 100vh;
        width: 100%;
        padding-bottom: 100px;
        padding: 0 0 120px;
        box-sizing: border-box;

        .videoItem {
            padding:20px;
            box-sizing: border-box;

            video {
                border-radius: 4px;
                background-color: #999;
            }

            .videoName {
                font-size: 28px;

            }
        }
    }

    .iframes {
        overflow: hidden;
        overflow-y: auto;
    }

    ::v-deep .tabs {
        position: fixed;
        top: 0;
        width: 100%;

        .el-tabs__header {
            margin-bottom: 10px;
            background-color: #fff;

            .el-tabs__nav-wrap {
                padding: 0 20px;
            }
        }

        .el-tabs__item {
            height: 90px;
            line-height: 90px;
            font-size: 28px;
        }

        .el-collapse-item__header {
            height: 90px;

            .title {
                display: flex;
                align-items: center;
                padding: 0 20px;
                font-size: 28px;

                img {
                    width: 50px;
                }

                span {
                    margin-left: 20px;
                }
            }

        }
    }

}
</style>
